import { render, staticRenderFns } from "./axis-alone.md?vue&type=template&id=0a2eaace&"
import script from "./axis-alone.md?vue&type=script&lang=js&"
export * from "./axis-alone.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2eaace')) {
      api.createRecord('0a2eaace', component.options)
    } else {
      api.reload('0a2eaace', component.options)
    }
    module.hot.accept("./axis-alone.md?vue&type=template&id=0a2eaace&", function () {
      api.rerender('0a2eaace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/axis/axis-alone.md"
export default component.exports